import { apiRequest } from '@/lib/api/client'

import {
  createGroupOrderResponseSchema,
  type CreateGroupOrderInput,
} from '@/features/group/order-charge'

import { orderListPayloadSchema, type OrderListFilters } from './schema'

/**
 * WEBLP-3185: list orders across all verified groups. The endpoint returns the
 * payload at the top level (no `{ data: ... }` envelope), so `unwrapResponse`
 * is false here. The customer is taken from the bearer token; there is no group
 * ID in the path.
 */
export function fetchOrderList(filters: OrderListFilters = {}, signal?: AbortSignal) {
  return apiRequest('/v1/algo-pos-be/liotitip/order', {
    schema: orderListPayloadSchema,
    unwrapResponse: false,
    searchParams: {
      page: filters.page,
      per_page: filters.perPage,
      groups: filters.groups,
      sources: filters.sources,
      order_status: filters.orderStatus,
      invoice_status: filters.invoiceStatus,
      search: filters.search,
    },
    signal,
  })
}

/**
 * Create a manual "Order Mandiri" that is not tied to a WhatsApp group, mirroring
 * the flat list endpoint above (no group ID in the path). Same create payload as
 * the group-scoped create. If the backend has not enabled this yet it returns an
 * error that the form surfaces, rather than any fabricated success.
 */
export function createStandaloneOrder(body: CreateGroupOrderInput, signal?: AbortSignal) {
  return apiRequest('/v1/algo-pos-be/liotitip/order', {
    method: 'POST',
    schema: createGroupOrderResponseSchema,
    unwrapResponse: false,
    body,
    signal,
  })
}
